module.exports = __webpack_public_path__ + "static/4-76bd1f2fe018c709588d4ac3fa601287.png";